import React, {useCallback, useState} from 'react';
import {SelectSectionButton} from "../../../shared/ui";
import {Tooltip} from "@mui/material";
import {getAutoFillingVariants} from "../../../../store/helpers/getAutoFillingVariants";
import {useShelvingStore} from "../../../../store";
import shallow from "zustand/shallow";
import AutoFillModal from "../../../Modals/AutoFillModal/AutoFillModal";

export const AutofillButton = () => {
    const [showAutoFillModal, setShowAutoFillModal] = useState(false);

    const {addSectionInShelf, getCurrentShelf} = useShelvingStore((state) => ({
        addSectionInShelf: state.addSectionInShelving,
        getCurrentShelf: state.getCurrentShelving,
        shelving: state.shelving,
    }), shallow);

    const currentShelf = getCurrentShelf();
    const sections = currentShelf.sections;
    const totalLength = currentShelf.length;

    const handleOpenAutoFillModal = useCallback(() => {
        if (getAutoFillingVariants(currentShelf.length).length === 1) {
            getAutoFillingVariants(currentShelf.length)[0].map((w) => addSectionInShelf(w, false))
        } else {
            setShowAutoFillModal(true)
        }
    }, [totalLength, addSectionInShelf, getCurrentShelf])
    return (
        <>
            <Tooltip title={sections.length ? 'Автозаполнение доступно только на пустой стене' : ''}>
                        <span>
                            <SelectSectionButton onClick={handleOpenAutoFillModal} disabled={!!sections.length}>
                                Автозаполнение
                            </SelectSectionButton>
                        </span>
            </Tooltip>
            {showAutoFillModal
                && <AutoFillModal
                    onClose={() => setShowAutoFillModal(false)}
                    isOpenModal={showAutoFillModal}
                    addSectionInShelf={addSectionInShelf}
                    currentShelf={currentShelf}
                />}
        </>

    );
};

